import cn from 'classnames';
import { SwiperSlide } from 'swiper/react';
import dynamic from 'next/dynamic';
import SectionTitle from 'UI/components/SectionTitle';
import { REVEAL_ANIMATION_PROPS } from 'utils/constants';
import { useState } from 'react';
import Svg from 'UI/components/Svg';
import useCardsSection from './utils/useCardsSection';
import styles from './AssessmentCtaSection.module.scss';
import CardsSection from '../CardsSection';

const AssessmentCtaSection = (props) => {
  const {
    className,
  } = useCardsSection(props);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.sectionContainer}>
      <div
        className={cn(styles.badge, { [styles.isHidden]: isOpen })}
        onClick={() => setIsOpen(true)}
      >
        Take Assessment
        <span
          className={styles.arrow}
        >
          <Svg
            type="arrowRight"
            className={styles.icon}
          />
        </span>
      </div>
      <section className={cn(className, { [styles.isOpen]: isOpen })}>
        <div
          onClick={() => setIsOpen(false)}
          className={styles.close}
        >
          <Svg
            type="xClose"
            className={styles.icon}
          />
        </div>
        <CardsSection {...props} />
      </section>
    </div>
  );
};

export default AssessmentCtaSection;
